import script from "./TurnView.vue?vue&type=script&setup=true&lang=js"
export * from "./TurnView.vue?vue&type=script&setup=true&lang=js"

import "./TurnView.vue?vue&type=style&index=0&id=1339c414&lang=scss"

const __exports__ = script;

export default __exports__